
window.App = {

	init: function() {
		var self = this;
		self.bindHandlers();
	},

	bindHandlers: function() {
		var self = this;
		self.advanceSearch();
		self.dateFloatingLabel();
        self.passMeter();
	},

	advanceSearch: function() {
		var self = this;
		$('body').on('click', '.advance-search', function(e) {
	        e.preventDefault();
	        e.stopPropagation();
	        var el = $(".advance-search-container");
	        if ($(this).hasClass("collapse")) {
	            $(this).removeClass("collapse").addClass("expand");
	            el.slideUp(200);
	            $('.filters').show();
	        } else {
	            $(this).removeClass("expand").addClass("collapse");
	            el.slideDown(200);
	            $('.filters').hide();
	        }
	    });
	},

	dateFloatingLabel: function() {
        $('body').on('click change focus', '.date-picker .form-control', function(e) {
        	if ($(this).val().length !== "") {
        		$(this).addClass('edited');
            } else {
            	$(this).removeClass('edited');
            }
        });
	},
    passMeter: function() {
        var options = {
            onKeyUp: function (evt) {
                $(evt.target).pwstrength("outputErrorList");
            }
        };
        $('#new_pass:password').pwstrength(options);
    }

};

window.App.init();


